module.exports = __webpack_public_path__ + "static/media/care-services.2ea1a234.jpg";